import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M13.95 11c-.249-1.97-1.912-3.5-3.95-3.5S6.299 9.03 6.05 11H4v1h12v-1h-2.05zm-6.899 0C7.291 9.584 8.517 8.5 10 8.5s2.71 1.084 2.949 2.5H7.05z',
  ],
  height: 20,
  width: 20,
});
